import { useTranslation } from 'react-i18next'

import { ButtonWithSpinner } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ResetToDefaultButton = ({ onClick, loading, disabled }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <ButtonWithSpinner
        variant="outlined"
        onClick={onClick}
        loading={loading}
        disabled={disabled}
        defaultLabel={t('Restablecer valores por defecto')}
        loadingLabel={t('Restableciendo valores por defecto')}
      />
    </Styles.Container>
  )
}

export default ResetToDefaultButton
